/* @flow @format */
import { Link, type ContextRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { get } from 'lodash';
import F from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';

import { AvatarContext } from '@sonyged/ext-proc';

import type { Dispatch } from '../redux/types';
import { getEntities } from '../redux/reducer';
import { getHasContestType } from '../redux/reducer/entities';
import { setConfigMute } from '../redux/reducer/config';
import { updateProfileSuccess } from '../redux/reducer/profile';
import AppContext from '../AppContext';
import AvatarSelector from './AvatarSelector';
import ProcDropdownMenu from '../utils/ProcDropdownMenu';
import api from '../graphql/api';

type OwnProps = {|
  ...ContextRouter,
|};

type Props = {|
  ...OwnProps,
  avatar: ?string,
  mute: boolean,
  hasIce: boolean,
  hasPizza: boolean,
  hasSushi: boolean,
  hasIceA: boolean,
  hasPizzaA: boolean,
  hasSushiA: boolean,
  updateProfileSuccess: typeof updateProfileSuccess,
  setConfigMute: typeof setConfigMute,
|};

type States = {
  avatarModal: boolean,
};

class HomePage extends React.Component<Props, States> {
  static contextType = AppContext;

  requestId: AnimationFrameID;

  constructor(props: Props) {
    super(props);

    (this: any).handleAvatarSelected = this.handleAvatarSelected.bind(this);

    this.state = {
      avatarModal: false,
    };

    const search = props.location.search;
    switch (search) {
      case '?sound=true':
        this.props.setConfigMute(false);
        break;
      case '?sound=false':
        this.props.setConfigMute(true);
        break;
      default:
        return;
    }
    props.history.replace('/');
  }

  componentDidMount() {
    this.context.soundController.bgmPlay('proc_chat_top01_home_re2', true);

    // If browser reload this page or access to this page directly,
    // The parent dom is NOT rendered and the IntroModal try to refer to it and failed.
    // This code assures that the parent dom is rendered once.
    this.requestId = requestAnimationFrame(() => {
      this.forceUpdate();
    });
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.requestId);
  }

  render() {
    const { hasIce, hasPizza, hasSushi, hasIceA, hasPizzaA, hasSushiA } = this.props;
    return (
      <div id={'proc-index-page-root'} className={'proc-index-page'}>
        <AvatarContext.Provider value={this.props.avatar}>
          <AvatarSelector
            avatar={this.props.avatar}
            isOpened={!this.props.avatar || this.state.avatarModal}
            onSelect={this.handleAvatarSelected}
          />
        </AvatarContext.Provider>
        <div className={'proc-outer'}>
          <div className={'proc-contents'}>
            <div className={'title gray100-color'}>
              <span className={'proc-huge-font'}>ホーム</span>
              <div className={'button-container'}>
                <div className={'proc-button icon secondary20-border-color'} onClick={this.onSoundClick}>
                  <i className={this.props.mute ? 'icon-proc-sound-off' : 'icon-proc-sound-on'} />
                </div>
                <ProcDropdownMenu
                  menuTopClassName={'setting-menu'}
                  className={'proc-button icon secondary20-border-color'}
                  menuIconClassName={'icon-proc-setting'}
                >
                  <div className={'proc-menu-item bold'} onClick={this.onAvatarMenuItemClick.bind(this)}>
                    キャラクター かくにん
                  </div>
                  <Link to="/z-pro-privacy" target="_blank" className="proc-menu-item bold">
                    プライバシーポリシー
                  </Link>
                  <Link to="/z-pro-term" target="_blank" className="proc-menu-item bold">
                    利用規約
                  </Link>
                  <Link to="/z-pro-external-destination-list" target="_blank" className="proc-menu-item bold">
                    外部送信一覧
                  </Link>
                </ProcDropdownMenu>
              </div>
            </div>

            {hasIce && (
              <div className="theme-container">
                <Link to="/ice/welcome" className={'image-container tertiary100-bg-color'}>
                  <img className="image" src={'/images/pages/top/img_theme_ice@3x.png'} />
                </Link>
                <div className={'title proc-medium-font gray100-color'}>アイスクリームやさんに なろう</div>
              </div>
            )}

            {hasPizza && (
              <div className="theme-container">
                <Link to="/pizza/welcome" className={'image-container pizza tertiary100-bg-color'}>
                  <img className="image" src={'/images/pages/top/img_theme_pizza@3x.png'} />
                </Link>
                <div className={'title proc-medium-font gray100-color'}>ピザやさんに なろう</div>
              </div>
            )}

            {hasSushi && (
              <div className="theme-container">
                <Link to="/sushi/welcome" className={'image-container sushi tertiary100-bg-color'}>
                  <img className="image" src={'/images/pages/top/img_theme_sushi@3x.png'} />
                </Link>
                <div className={'title proc-medium-font gray100-color'}>おすしやさんになろう</div>
              </div>
            )}

            {hasIceA && (
              <div className="theme-container">
                <Link to="/ice-a/welcome" className={'image-container ice tertiary100-bg-color'}>
                  <img className="image" src={'/images/pages/top/img_theme_ice-a@3x.png'} />
                </Link>
                <div className={'title proc-medium-font gray100-color'}>アイスクリーム屋さんになろう</div>
              </div>
            )}

            {hasPizzaA && (
              <div className="theme-container">
                <Link to="/pizza-a/welcome" className={'image-container pizza tertiary100-bg-color'}>
                  <img className="image" src={'/images/pages/top/img_theme_pizza-a@3x.png'} />
                </Link>
                <div className={'title proc-medium-font gray100-color'}>ピザ屋さんになろう</div>
              </div>
            )}

            {hasSushiA && (
              <div className="theme-container">
                <Link to="/sushi-a/welcome" className={'image-container sushi tertiary100-bg-color'}>
                  <img className="image" src={'/images/pages/top/img_theme_sushi-a@3x.png'} />
                </Link>
                <div className={'title proc-medium-font gray100-color'}>おすし屋さんになろう</div>
              </div>
            )}
            <div className={'push'} />
          </div>
          <div className={'proc-footer copyright'}>
            <div className="logo-image image" />
            <div className={'copyright'}>©2019 Sony Global Education, Inc.</div>
          </div>
        </div>
      </div>
    );
  }

  onSoundClick = () => {
    const { mute, setConfigMute } = this.props;
    setConfigMute(!mute);
    this.context.soundController.mute(!mute);
    this.context.soundController.bgmPlay('proc_chat_top01_home_re2', true);
  };

  onAvatarMenuItemClick() {
    this.setState({ avatarModal: true });
  }

  handleAvatarSelected(avatar: string) {
    // TODO loading?
    api.updateUserProfile({ avatar, nickname: null }).then(({ data: { updateExamineeProfile } = {} }) => {
      this.props.updateProfileSuccess(updateExamineeProfile);
      this.setState({ avatarModal: false });
    });
  }
}

HomePage.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
};

type ContainerProps = {|
  ...Props,
|};

class HomePageContainer extends React.Component<ContainerProps> {
  render() {
    return <HomePage {...this.props} />;
  }
}

const makeSelectHasContestKind = (contestType: string) =>
  F.pipe(getEntities, (state) => getHasContestType(state, { contestType }));

const selectAvatar = (state) => get(state, 'profile.avatar');
const selectMute = (state) => state.config.mute;
const selectHasIce = makeSelectHasContestKind('ice');
const selectHasPizza = makeSelectHasContestKind('pizza');
const selectHasSushi = makeSelectHasContestKind('sushi');
const selectHasIceA = makeSelectHasContestKind('ice-a');
const selectHasPizzaA = makeSelectHasContestKind('pizza-a');
const selectHasSushiA = makeSelectHasContestKind('sushi-a');

const mapStateToProps = createStructuredSelector({
  avatar: selectAvatar,
  mute: selectMute,
  hasIce: selectHasIce,
  hasPizza: selectHasPizza,
  hasSushi: selectHasSushi,
  hasIceA: selectHasIceA,
  hasPizzaA: selectHasPizzaA,
  hasSushiA: selectHasSushiA,
});

const mapDispatchToProps = (dispatch: Dispatch, _: OwnProps) => ({
  ...bindActionCreators({ setConfigMute }, dispatch),
  updateProfileSuccess: (input) => dispatch(updateProfileSuccess(input)),
});

export default connect<ContainerProps, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(HomePageContainer);
